export default __webpack_public_path__ + "static/media/feature_1@2x.808536d8.png";